// src/components/study/SupportContent.tsx
// =====================================================================
// CONTEÚDO DE APOIO - IDENTIDADE GRAIA
// Exibe material complementar abaixo da área de flashcards
// =====================================================================

import React, { useEffect, useRef } from 'react';
import './SupportContent.css';
import { X } from 'lucide-react';

interface SupportContentProps {
    isVisible: boolean;
    content: string;
    onClose: () => void;
    onImageClick?: (imageUrl: string) => void;
}

export const SupportContent: React.FC<SupportContentProps> = ({
    isVisible,
    content,
    onClose,
    onImageClick
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    // ✅ Scroll suave ao abrir
    useEffect(() => {
        if (isVisible && containerRef.current) {
            setTimeout(() => {
                containerRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        }
    }, [isVisible]);

    // ✅ Efeito para capturar cliques em imagens dentro do HTML injetado
    useEffect(() => {
        if (!isVisible || !containerRef.current) return;

        const handleGlobalClick = (e: MouseEvent) => {
            const target = e.target as HTMLElement;

            // Procura a imagem mais próxima do ponto clicado
            const clickedImage = target.closest('img');

            if (clickedImage && containerRef.current?.contains(clickedImage)) {
                const imgSrc = clickedImage.src;
                console.log("📸 Imagem detectada no conteúdo de apoio:", imgSrc);

                if (onImageClick) {
                    onImageClick(imgSrc);
                }
            }
        };

        // Adicionamos o evento ao container principal do suporte
        const currentContainer = containerRef.current;
        currentContainer.addEventListener('click', handleGlobalClick);

        return () => {
            currentContainer.removeEventListener('click', handleGlobalClick);
        };
    }, [isVisible, onImageClick]);

    if (!isVisible) return null;

    return (
        <div className="support-content-section" ref={containerRef}>
            <div className="support-content-container">
                {/* Header */}
                <div className="support-content-header">
                    <h2 className="support-title">Conteúdo de Apoio</h2>
                    <button
                        className="btn-close-support"
                        onClick={onClose}
                        aria-label="Fechar conteúdo de apoio"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Body */}
                <div
                    className="support-content-body"
                    style={{ cursor: 'zoom-in' }}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </div>
        </div>
    );
};